import { render, staticRenderFns } from "./SubcategoryPage.vue?vue&type=template&id=5a041912"
import script from "./SubcategoryPage.vue?vue&type=script&lang=js"
export * from "./SubcategoryPage.vue?vue&type=script&lang=js"
import style0 from "./SubcategoryPage.vue?vue&type=style&index=0&id=5a041912&prod&lang=css"
import style1 from "./SubcategoryPage.vue?vue&type=style&index=1&id=5a041912&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports